import React from 'react';
import { Table, TableProps } from '@otp/ui';
import { getTableConfig } from './config';
import { useTranslation } from 'react-i18next';
import type { WttpQuestionnaireResponsesData } from '../types';
import { WttpQuestionnaireResponseAction } from 'src/components/wttp/questionnaire-responses/list/table/columns/actions/actions-modals';
import { useCan } from 'src/utils/can';

type WttpQuestionnaireResponsesTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Array<WttpQuestionnaireResponsesData>;
  onActionFinished?: (action: WttpQuestionnaireResponseAction) => void;
};

export const WttpQuestionnaireResponsesTable = ({
  data,
  className,
  options,
  onActionFinished,
  ...props
}: WttpQuestionnaireResponsesTableProps) => {
  const { t } = useTranslation();
  const { can } = useCan();
  const tableConfig = getTableConfig(data, { t, onActionFinished, can });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
